import React from "react";
import {
  buttonBaseClass,
  buttonSizeClasses,
  buttonVariantClasses,
  cn,
} from "./formStyles";

const Button = ({
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  icon: Icon,
  className = "",
  children,
  type = "button",
  ...props
}) => (
  <button
    type={type}
    disabled={disabled || loading}
    className={cn(
      buttonBaseClass,
      buttonSizeClasses[size] || buttonSizeClasses.md,
      buttonVariantClasses[variant] || buttonVariantClasses.primary,
      className
    )}
    {...props}
  >
    {Icon ? <Icon size={16} /> : null}
    {loading && !children ? "Carregando..." : children}
  </button>
);

export default Button;
